import Dexie from "dexie";

export const OFFLINE_DB_NAME = "logboek24Offline";

export const offlineDb = new Dexie(OFFLINE_DB_NAME);

offlineDb.version(1).stores({
  entries: "tempId, updatedAt, createdAt",
  syncQueue: "tempId, queuedAt, updatedAt, createdAt",
  agendaCache: "cacheKey, date, view, updatedAt",
});

offlineDb.version(2).stores({
  entries: "tempId, updatedAt, createdAt",
  syncQueue: "tempId, queuedAt, updatedAt, createdAt",
  agendaCache: "[scopeKey+cacheKey], scopeKey, cacheKey, date, view, updatedAt",
  workorderCollections: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  workorderDetails: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  workorderFinancial: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  referenceData: "[scopeKey+type], scopeKey, type, updatedAt",
});

offlineDb.version(3).stores({
  entries: "tempId, updatedAt, createdAt",
  syncQueue: "tempId, queuedAt, updatedAt, createdAt",
  agendaCache: "[scopeKey+cacheKey], scopeKey, cacheKey, date, view, updatedAt",
  workorderCollections: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  workorderDetails: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  workorderFinancial: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  referenceData: "[scopeKey+type], scopeKey, type, updatedAt",
  opnames: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  opnameDetails: "[scopeKey+opnameId], scopeKey, opnameId, updatedAt",
  lookupClients: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  lookupProjects: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  lookupWorkorders: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  draftOpnames: "[scopeKey+draftId], scopeKey, draftId, updatedAt",
});

offlineDb.version(4).stores({
  entries: "tempId, updatedAt, createdAt",
  syncQueue:
    "tempId, scopeKey, status, queuedAt, createdAt, updatedAt, nextRetryAt, entityType, entityId, type, [scopeKey+status], [scopeKey+entityId]",
  agendaCache: "[scopeKey+cacheKey], scopeKey, cacheKey, date, view, updatedAt",
  workorderCollections: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  workorderDetails: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  workorderFinancial: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  referenceData: "[scopeKey+type], scopeKey, type, updatedAt",
  opnames: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  opnameDetails: "[scopeKey+opnameId], scopeKey, opnameId, updatedAt",
  lookupClients: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  lookupProjects: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  lookupWorkorders: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  draftOpnames: "[scopeKey+draftId], scopeKey, draftId, updatedAt",
});

offlineDb.version(5).stores({
  entries: "tempId, updatedAt, createdAt",
  syncQueue:
    "tempId, scopeKey, status, queuedAt, createdAt, updatedAt, nextRetryAt, entityType, entityId, type, [scopeKey+status], [scopeKey+entityId]",
  agendaCache: "[scopeKey+cacheKey], scopeKey, cacheKey, date, view, updatedAt",
  workorderCollections: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  workorderDetails: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  workorderFinancial: "[scopeKey+workorderId], scopeKey, workorderId, updatedAt",
  referenceData: "[scopeKey+type], scopeKey, type, updatedAt",
  opnames: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  opnameDetails: "[scopeKey+opnameId], scopeKey, opnameId, updatedAt",
  lookupClients: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  lookupProjects: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  lookupWorkorders: "[scopeKey+cacheKey], scopeKey, cacheKey, updatedAt",
  draftOpnames: "[scopeKey+draftId], scopeKey, draftId, updatedAt",
  opnamePhotoBlobs: "[scopeKey+photoId], scopeKey, photoId, entityId, updatedAt",
});

export default offlineDb;
